module.exports = __webpack_public_path__ + "static/media/artist_lop-y_b.f757292e.png";